import React from "react";
import styled from "styled-components";


const BlogCard = (props) =>{
    return(
        <Container>
            <Img src={props.image}/>
            <Title>{props.title}</Title>
            <br/>
            <Description>{props.description}</Description>
        </Container>
    )
};


export default BlogCard;

const Img = styled.img`
width: 100%;
height: 60%;
object-fit: cover;
border-radius: 3px;
`;

const Container = styled.div`
width: 17%;
height: 250px;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
background-color: white;
padding: 40px 20px;
border-radius: 10px;
margin: 20px 30px;
box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;

:hover{
background: linear-gradient( 150deg ,indigo 30%, green 54.05%, orangered 65%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
}

@media Screen and (max-width: 768px){
    width: 85%;
    margin: 10px 0;
}

@media Screen and (max-width: 375px){
    width: 90%;
    margin: 10px 0px;
}
@media Screen and (max-width: 320px){
    height: 200px;
    width: 80%;
    margin: 5px 0px;
}
`;
const Description = styled.div`
text-align: center;
`;
const Title = styled.div`
font-size: 25px;
text-align: center;
`;